var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Main',{attrs:{"language":_vm.language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }